import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

const initialState = {
  tracks: {}, 
  loading: false,
  error: null,
  pagination: {},
  selectedTrack: null
};

/* ================== THUNKS ================== */

export const fetchTracks = createAsyncThunk(
  'tracks/fetch',
  async ({ albumId, page = 1, limit = 10, search = '' }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/api/admin/tracks/${albumId}`, {
            params: { page, limit, search }
        });
        console.log(response ,"response")
        return {
            data: response.data?.data?.records || [],
            pagination: response.data?.data?.pagination || {},
            nextTrackNumber: response.data?.data?.nextTrackNumber || 1
        };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const createTrack = createAsyncThunk(
  'tracks/create',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/admin/tracks', 
        payload
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchTrackById = createAsyncThunk(
  'tracks/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      console.log(id,'id');
      const response = await axiosInstance.get(`/api/admin/tracks/detail/${id}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const fetchTrackBySlug = createAsyncThunk(
  'tracks/fetchBySlug',
  async (slug, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/api/admin/tracks/slug/${slug}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const updateTrack = createAsyncThunk(
  'tracks/update',
  async ({ id, formData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`/api/admin/tracks/${id}`, formData);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteTrack = createAsyncThunk(
  'tracks/delete',
  async ({ id }, { rejectWithValue }) => {
    try {
      console.log(id,'id');
      await axiosInstance.delete(`/api/admin/tracks/${id}`);
      return { id };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const scheduleTrackRequest = createAsyncThunk(
  'tracks/scheduleTrackRequest',
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/tracks/${id}/schedule`, payload);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const publishTrackRequest = createAsyncThunk(
  'tracks/publishTrackRequest',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`/api/admin/tracks/${id}/publish`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);

export const deleteTrackScheduleRequest = createAsyncThunk(
  'tracks/deleteTrackScheduleRequest',
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.delete(`/api/admin/tracks/${id}/schedule`);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message);
    }
  }
);


/* ================== SLICE ================== */

const trackSlice = createSlice({
  name: 'tracks',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
        /* FETCH */
        .addCase(fetchTracks.pending, (state) => {
            state.loading = true;
        })
        .addCase(fetchTracks.fulfilled, (state, action) => {
            const { data, pagination, nextTrackNumber } = action.payload;
            state.loading = false;
            state.pagination = pagination;
            state.tracks = data;
            state.nextTrackNumber = nextTrackNumber;
        })
        .addCase(fetchTracks.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* CREATE */
        // .addCase(createTrack.fulfilled, (state, action) => {
            
        // })

        .addCase(fetchTrackById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedTrack = action.payload;
        })
        .addCase(fetchTrackById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        .addCase(fetchTrackBySlug.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedTrack = action.payload;
        })
        .addCase(fetchTrackBySlug.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        /* UPDATE */
        .addCase(updateTrack.fulfilled, (state, action) => {        
            console.log(state,'state');
        })
        .addCase(updateTrack.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })

        .addCase(scheduleTrackRequest.fulfilled, (state, action) => {
            console.log(state,'state');
        })

        .addCase(publishTrackRequest.fulfilled, (state, action) => {
            console.log(state,'state');
        })

        .addCase(deleteTrackScheduleRequest.fulfilled, (state, action) => {
            console.log(state,'state');
        })

      /* DELETE */
      .addCase(deleteTrack.fulfilled, (state, action) => {
        state.tracks = state.tracks.filter((p) => p._id !== action.payload);
      });
  }
});

export default trackSlice.reducer;